// extracted by mini-css-extract-plugin
export default {"container":"BW-z","title":"CW-z","link":"DW-z"};